import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';

import Footer from '../../Components/Footer/Footer';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';
import FuelTypesApi from '../../Services/FuelTypes';

import ActionButtonFactory from './ActionButtons/ActionButtonFactory';
import CancelButton from './ActionButtons/CancelOrderButton';

const timeMask = 'm/d/yy h:MM:ss TT Z';

class OrdersPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fboId: props.fboId,
      id: undefined,
      orderNumber: undefined,
      comments: undefined,
      customerName: undefined,
      tailNumber: '',
      location: undefined,
      expectedFulfillDate: undefined,
      createdAt: undefined,
      closedAt: undefined,
      canceledAt: undefined,
      fuelTypeId: undefined,
      oilTypeId: undefined,
      towType: undefined,
      towOrder: {
        towOrder: 0,
        orderId: this.props.match.params.orderId,
        type: undefined,
      },
      oilOrder: {
        oilOrderId: 0,
        orderId: this.props.match.params.orderId,
        oilTypeId: undefined,
        quantity: undefined,
      },
      fuelOrder: undefined,
      fuelOrderTypeName: undefined,
    };

    this.goBack = this.goBack.bind(this);
    this.fuelTypeDisplayName = this.fuelTypeDisplayName.bind(this);

    this.statusChangeSuccess = this.statusChangeSuccess.bind(this);
  }

  componentWillMount() {
    this.fetchData(this);
  }

  async fetchData() {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${this.props.fboId}/orders/${this.props.match.params.orderId}`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    const fuelTypes = await FuelTypesApi.get();

    this.request = Api.get(endPoint, {
      headers: myHeaders,
    }, true).then((response) => {
      const order = response.order;
      const towOrderType = order.towOrder ? order.towOrder.type : undefined;
      const firstFuelOrder = order.fuelOrders[0];

      let fuelOrderTypeName = null;
      if (firstFuelOrder) {
        fuelTypes.forEach((fuelType) => {
          if (fuelType.id === firstFuelOrder.fuelTypeId) {
            fuelOrderTypeName = fuelType.name;
          }
        });
      }

      this.setState({
        id: order.id,
        orderNumber: order.orderNumber,
        comments: order.comments,
        customerName: order.customerName,
        tailNumber: order.tailNumber,
        location: order.location,
        towType: towOrderType,
        order,
        towOrder: order.towOrder,
        oilOrder: JSON.parse(JSON.stringify(order.oilOrder)),
        fuelOrder: firstFuelOrder,
        fuelOrderTypeName,
        expectedFulfillDate: order.expectedFulfillDate,
        createdAt: order.createdAt,
        closedAt: order.closedAt,
        canceledAt: order.canceledAt,
      });
    });
  }

  statusChangeSuccess(order, defaultRoute) {
    if (defaultRoute) {
      const { history } = this.props;
      history.push(defaultRoute);
    } else {
      window.location.reload();
    }
  }

  statusChangeError(order) {
    this.notificationSystem.addNotification({
      message: `Order #${order.orderNumber} could not be updated`,
      level: 'error',
      position: 'bc'
    });
  }

  goBack() {
    const { history } = this.props;
    history.goBack();
  }

  fuelTypeDisplayName() {
    return this.state.fuelOrderTypeName ?
      this.state.fuelOrderTypeName :
      `(Unknown fuel type) ${this.state.fuelOrder.fuelTypeId}`;
  }

  renderFuelRequests(request) {
    return (
      <span>
        <div className="title">Requests</div>
        {request.orders.map((fuelOrder, i) => (
          <span>
            {fuelOrder.type !== 'none' &&
              <p className="order-request-item">
                <strong>{fuelOrder.location} {fuelOrder.position}:</strong> &nbsp;
                {fuelOrder.type === 'gal' &&
                  <span>{fuelOrder.quantity}&nbsp;</span>
                }
                {fuelOrder.type}
              </p>
            }
          </span>))}
      </span>
    );
  }

  render() {
    const orderString = this.state.orderNumber ? `#${this.state.orderNumber}` : '';
    const orderId = this.state.order ? this.state.order.id : null;
    const showCancelButton = this.state.order && this.state.order.status === 'todo';

    return (
      <div className="app">
        <NotificationSystem ref={(node) => { this.notificationSystem = node; }} />
        <main className="page-content">
          <div className="normal-page-header">
            <h1 className="left">Order {orderString}</h1>
            <div className="clear" />
          </div>

          <div className="create-form page-content-items">

            <article className="order-details">
              <div className="order-action-wrapper">
                {this.state.order &&
                  ActionButtonFactory.build(this.props.fboId, this.state.order, this.statusChangeSuccess, this.statusChangeError)
                }
                <Link
                  className="btn btn-small btn-alternative-options"
                  to={{ pathname: `/orders/${this.state.id}/edit`, state: { orderId: this.state.id } }}
                  href={{ pathname: `/orders/${this.state.id}/edit`, state: { orderId: this.state.id } }}
                >
                    Edit
                </Link>
                {showCancelButton &&
                  <CancelButton
                    fboId={this.props.fboId}
                    orderId={orderId}
                    onSuccess={this.statusChangeSuccess}
                    onError={this.statusChangeError}
                  />
                }
                {this.state.order && ['in progress', 'closed', 'invoiced'].indexOf(this.state.order.status) >= 0 &&
                  <Link className="btn btn-small btn-alternative-options" to={{ pathname: `/orders/${this.state.id}/rollback`, state: { orderId: this.state.id } }}>
                      Rollback Status
                  </Link>
                }
              </div>
              <div className="clear" />
              {/* @TODO - Joe: Start the order details chunk here */ }
              {/* Use this (not OrderAttributes.js) as your template */ }
              <div className="column-one-third">
                <p>
                  <strong>Customer Name:</strong> {this.state.customerName}
                </p>
              </div>
              <div className="column-one-third">
                <p>
                  <strong>Tail Number:</strong>
                  <Link
                    href={{ pathname: `/reports/customer/${this.state.tailNumber.replace(' ', '_')}` }}
                    to={{ pathname: `/reports/customer/${this.state.tailNumber.replace(' ', '_')}` }}
                    params={{ fboId: this.props.fboId }}
                  >
                    {this.state.tailNumber}
                  </Link>
                </p>
              </div>
              <div className="column-one-third">
                <p>
                  <strong>Plane Location:</strong> {this.state.location}
                </p>
              </div>
              <p>
                <strong>Expected Fulfill Date:</strong> {dateFormat(this.state.expectedFulfillDate, timeMask) }
              </p>
              {this.state.fuelOrder &&
                <span>
                  <p>
                    <strong> Fuel Type:</strong> { this.fuelTypeDisplayName() }
                  </p>
                  <div className="fuel-order-request">
                    {this.renderFuelRequests(this.state.fuelOrder.request)}
                  </div>
                </span>
              }
              {this.state.oilOrder && this.state.oilOrder.oilType &&
                <span>
                  <p>
                    <strong>Oil Type:</strong> {this.state.oilOrder.oilType.name}
                  </p>
                  <p>
                    quantity: {this.state.oilOrder.quantity} quarts
                  </p>
                </span>
              }
              {this.state.towType &&
                <p>
                  <strong>TowOrder:</strong> {this.state.towType}
                </p>
              }
              <p>
                <strong>Order Notes:</strong> {this.state.comments}
              </p>
              {this.state.createdAt &&
                <p>
                  <strong>Created Date:</strong> {dateFormat(this.state.createdAt, timeMask) }
                </p>
              }
              {this.state.closedAt &&
                <p>
                  <strong>Closed Date:</strong> {dateFormat(this.state.closedAt, timeMask) }
                </p>
              }
              {this.state.canceledAt &&
                <p>
                  <strong>Canceled Date:</strong> {dateFormat(this.state.canceledAt, timeMask) }
                </p>
              }

              {/* @TODO - Joe: End the order details chunk here */ }
            </article>
            <div className="clear" />
          </div>
          <Footer />
        </main>
      </div>
    );
  }
}


OrdersPage.propTypes = {
  history: PropTypes.shape({}).isRequired,
  fboId: PropTypes.number.isRequired,
};
export default OrdersPage;




// WEBPACK FOOTER //
// ./src/Containers/Orders/OrderPage.js